import React from 'react';
import { Asset } from '../../../types/assets';
import { Card, Container, Grid, Typography, Avatar } from '@mui/material';
import AttachmentIcon from '../../../assets/images/attachments.svg';
import useMediaQuery from '@mui/material/useMediaQuery';
import { stringAvatar } from './helpers';
import { RichText } from '../../../components/Text/RichText';
import {
  renderGoalHeading,
  renderGoalImage,
  renderGoalSubHeading,
} from '../../../utils/helpers';

interface props {
  asset: Asset;
}

const Overview = ({ asset }: props) => {
  const isSmallScreen = useMediaQuery('(max-width: 1000px)');
  const isMDScreen = useMediaQuery('(max-width: 900px) and (min-width: 800px)');

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={8}
          style={{
            paddingLeft: isSmallScreen ? '20px' : '140px',
            paddingRight: isSmallScreen ? '20px' : '100px',
            marginTop: isMDScreen ? '500px' : '0',
          }}
        >
          <Typography>{asset?.company?.companySummary}</Typography>
          <ul style={{ paddingInlineStart: 0, listStyleType: 'none' }}>
            <li>
              •{' '}
              <span style={{ borderBottom: 'dashed 1px black' }}>
                Founded In
              </span>
              : {asset?.company?.foundedIn}
            </li>
            <li>
              •{' '}
              <span style={{ borderBottom: 'dashed 1px black' }}>
                HQ Location
              </span>
              : {asset?.company?.location}
            </li>
            <li>
              •{' '}
              <span style={{ borderBottom: 'dashed 1px black' }}>
                Locations
              </span>
              : {asset?.investmentInfo?.locations}
            </li>
            <li>
              •{' '}
              <span style={{ borderBottom: 'dashed 1px black' }}>Website</span>:{' '}
              <a
                href={
                  (asset?.company?.website?.startsWith('https://')
                    ? ''
                    : 'https://') + asset?.company?.website
                }
                target="_blank"
                style={{ color: 'black' }}
              >
                {asset?.company?.website}
              </a>
            </li>
            <li>
              • <span style={{ borderBottom: 'dashed 1px black' }}>ABN</span>:{' '}
              {asset?.company?.abn}
            </li>
            {/* <li>
              •{' '}
              <span style={{ borderBottom: 'dashed 1px black' }}>
                Investor Type
              </span>
              :{' '}
              {asset?.company?.investorType === 'Other Please state'
                ? asset?.company?.otherInvestorType
                : asset?.company?.investorType || ''}
            </li> */}
            {/* <li>
              •{' '}
              <span style={{ borderBottom: 'dashed 1px black' }}>
                Industry Classification
              </span>
              : {asset?.investmentInfo?.industryClassifications}
            </li> */}
          </ul>

          {asset?.overview?.summary && (
            <div
              id="overview"
              style={{
                borderBottom: 'solid 2px #ccc',
                paddingBottom: '20px',
                paddingTop: '40px',
              }}
            >
              <h2>Overview</h2>
              <RichText htmlContent={asset?.overview?.summary} />

              <h3>Purpose</h3>
              <RichText htmlContent={asset?.overview?.purpose} />

              <h3>Traction</h3>
              <RichText htmlContent={asset?.overview?.traction} />

              <h3>Use Of Funds</h3>
              <RichText htmlContent={asset?.overview?.useOfFund} />

              <h3>Vision</h3>
              <RichText htmlContent={asset?.overview?.vision} />

              {asset?.overview?.images?.length > 0 && (
                <img
                  src={asset?.overview?.images[0]}
                  style={{ width: '100%' }}
                />
              )}
            </div>
          )}

          {asset?.team &&
            asset?.team.length > 0 &&
            asset?.team.some(
              (member) =>
                member.name.trim() !== '' ||
                member.summary.trim() !== '' ||
                member.title.trim() !== ''
            ) && (
              <div
                id="keyteam"
                style={{
                  borderBottom: 'solid 2px #ccc',
                  paddingBottom: '20px',
                  paddingTop: '40px',
                }}
              >
                <h2>Key Team</h2>

                {asset?.team?.map((team, id) => {
                  const { name, summary, title, image } = team;
                  if (
                    name.trim() === '' &&
                    summary.trim() === '' &&
                    title.trim() === ''
                  ) {
                    return null;
                  }
                  return (
                    <div
                      key={id}
                      style={{ marginTop: '20px', marginBottom: '20px' }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={2} lg={1.5}>
                          {image ? (
                            <Avatar
                              sx={{
                                width: '70px',
                                height: '70px',
                                borderRadius: 3,
                              }}
                              alt={name}
                              variant="square"
                              src={image}
                            />
                          ) : (
                            <Avatar
                              variant="square"
                              {...stringAvatar(name || 'Jon Snow')}
                              style={{ width: '70px', height: '70px' }}
                            />
                          )}
                        </Grid>

                        <Grid item xs={12} sm={12} md={10} lg={10.5}>
                          <Typography>{name}</Typography>
                          <Typography color={'#6E7D91'}>{title}</Typography>

                          <Typography>{summary}</Typography>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
              </div>
            )}

          {/* {asset?.sustainabilityGoals && (
            <div
              id="goals"
              style={{
                borderBottom: 'solid 2px #ccc',
                paddingBottom: '20px',
                paddingTop: '40px',
              }}
            >
              <h2>Sustainability Goals</h2>

              {asset?.sustainabilityGoals instanceof Array ? (
                <>
                  {asset?.sustainabilityGoals?.map((goal, id) => {
                    return (
                      <div
                        key={id}
                        style={{
                          marginTop: '20px',
                          marginBottom: '20px',
                          display: 'flex',
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={1.5}
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src={renderGoalImage(goal)}
                              alt={`Goal ${goal}`}
                              style={{
                                width: 55,
                                height: 55,
                                borderRadius: 10,
                              }}
                            />
                          </Grid>
                          <Grid item xs={10.5}>
                            <p
                              style={{
                                marginBottom: 0,
                                fontWeight: 'bold',
                                fontSize: 16,
                              }}
                            >
                              {renderGoalHeading(goal)}
                            </p>
                            <p style={{ marginTop: 0 }}>
                              {renderGoalSubHeading(goal)}
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    );
                  })}
                </>
              ) : (
                <RichText htmlContent={asset?.sustainabilityGoals} />
              )}
            </div>
          )} */}

          {asset?.leadInvestors &&
            asset?.leadInvestors.length > 0 &&
            asset?.leadInvestors.some(
              (leadInvestor) =>
                leadInvestor.name.trim() !== '' ||
                leadInvestor.summary.trim() !== '' ||
                leadInvestor.title.trim() !== ''
            ) && (
              <div
                id="leadInvestors"
                style={{
                  borderBottom: 'solid 2px #ccc',
                  paddingBottom: '20px',
                  paddingTop: '40px',
                }}
              >
                <h2>Lead Investors</h2>

                {asset?.leadInvestors?.map((leadInvestor, id) => {
                  const { name, summary, title, image } = leadInvestor;
                  if (
                    name.trim() === '' &&
                    summary.trim() === '' &&
                    title.trim() === ''
                  ) {
                    return null; // Skip rendering if all fields are blank
                  }
                  return (
                    <div
                      key={id}
                      style={{ marginTop: '20px', marginBottom: '20px' }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={2} lg={1.5}>
                          {image ? (
                            <Avatar
                              sx={{
                                width: '70px',
                                height: '70px',
                                borderRadius: 3,
                              }}
                              alt={name}
                              variant="square"
                              src={image}
                            />
                          ) : (
                            <Avatar
                              variant="square"
                              {...stringAvatar(name || 'Jon Snow')}
                              style={{ width: '70px', height: '70px' }}
                            />
                          )}
                        </Grid>

                        <Grid item xs={12} sm={12} md={10} lg={10.5}>
                          <Typography>{name}</Typography>
                          <Typography color={'#6E7D91'}>{title}</Typography>
                          <Typography>{summary}</Typography>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
              </div>
            )}

          {asset?.attachments && asset?.attachments.length > 0 && (
            <div
              id="attachments"
              style={{
                borderBottom: 'solid 2px #ccc',
                paddingBottom: '20px',
                paddingTop: '40px',
              }}
            >
              <h2>Attachments</h2>

              <Card
                sx={{
                  borderRadius: '10px',
                  width: '100%',
                }}
              >
                {asset?.attachments?.map((attachment, id) => {
                  return (
                    <Grid
                      key={id}
                      container
                      justifyContent={'space-between'}
                      spacing={2}
                      sx={{ paddingX: '20px', borderBottom: '1px solid #ccc' }}
                    >
                      <Grid item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '10px',
                          }}
                        >
                          <img src={AttachmentIcon} alt="icon" />
                          <a
                            href={attachment}
                            target="_blank"
                            style={{ marginLeft: '5px', color: 'black' }}
                          >
                            {attachment &&
                              typeof attachment === 'string' &&
                              decodeURIComponent(
                                attachment.split('/').pop() || ''
                              )}
                          </a>
                        </div>
                      </Grid>
                    </Grid>
                  );
                })}
              </Card>
            </div>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              borderRadius: '10px',
              background: 'transparent',
              width: '98%',
              marginTop: !isSmallScreen ? '500px' : '15px',
            }}
          >
            <Typography
              sx={{
                padding: '10px',
                color: '#99A4B2',
              }}
            >
              On This Page
            </Typography>
            {asset?.overview?.summary && (
              <Typography
                sx={{
                  padding: '10px',
                }}
              >
                <a
                  href="#overview"
                  style={{ color: 'black', textDecoration: 'none' }}
                >
                  Overview
                </a>
              </Typography>
            )}

            {asset?.team &&
              asset?.team.length > 0 &&
              (asset?.team[0].name !== '' ||
                asset?.team[0].summary !== '' ||
                asset?.team[0].title !== '') && (
                <Typography
                  sx={{
                    padding: '10px',
                  }}
                >
                  <a
                    href="#keyteam"
                    style={{ color: 'black', textDecoration: 'none' }}
                  >
                    Key Team
                  </a>
                </Typography>
              )}

            {asset?.leadInvestors &&
              asset?.leadInvestors.length > 0 &&
              (asset?.leadInvestors[0].name !== '' ||
                asset?.leadInvestors[0].summary !== '' ||
                asset?.leadInvestors[0].title !== '') && (
                <Typography
                  sx={{
                    padding: '10px',
                  }}
                >
                  <a
                    href="#leadInvestors"
                    style={{ color: 'black', textDecoration: 'none' }}
                  >
                    Lead Investors
                  </a>
                </Typography>
              )}

            {asset?.sustainabilityGoals && (
              <Typography
                sx={{
                  padding: '10px',
                }}
              >
                <a
                  href="#goals"
                  style={{ color: 'black', textDecoration: 'none' }}
                >
                  Sustainability Goals
                </a>
              </Typography>
            )}

            {asset?.attachments && asset?.attachments.length > 0 && (
              <Typography
                sx={{
                  padding: '10px',
                }}
              >
                <a
                  href="#attachments"
                  style={{ color: 'black', textDecoration: 'none' }}
                >
                  Attachments
                </a>
              </Typography>
            )}
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Overview;
